"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importDefault(require("react"));
var semantic_ui_react_1 = require("semantic-ui-react");
var LoginModal_1 = __importDefault(require("../../login/LoginModal"));
var SuccessfulActivationStage = function () { return ((0, jsx_runtime_1.jsx)(semantic_ui_react_1.Grid, __assign({ className: "loopsignup", style: { marginTop: '150px', color: '#fff', textAlign: 'center' } }, { children: (0, jsx_runtime_1.jsxs)(semantic_ui_react_1.Grid.Row, { children: [(0, jsx_runtime_1.jsx)(semantic_ui_react_1.Image, { centered: true, size: "small", src: "/fanslogo.svg", alt: "logo" }), (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Divider, {}), (0, jsx_runtime_1.jsx)("h3", { children: "Account Activation Successful" }), (0, jsx_runtime_1.jsx)("p", { children: "You may now login using your email and password." }), (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Divider, {}), (0, jsx_runtime_1.jsx)("a", __assign({ href: "/", className: "btn communityBtn", style: { margin: 'auto' } }, { children: "Back Home" }))] }) }))); };
exports.default = SuccessfulActivationStage;
